/**
 * New value for a segment's start or stop after a keyboard nudge (#4029).
 *
 * Clamped so a start never goes below 0 or past its own stop, and a stop
 * never goes before its own start. Unclamped, repeated "start back" presses
 * produced negative timecodes (shown as -1:-1:-1.-17).
 */
export const nudgeSegmentTime = (
  segment: { start: number; stop: number },
  field: 'start' | 'stop',
  milliseconds: number
): number =>
  field === 'start'
    ? Math.min(Math.max(0, segment.start + milliseconds), segment.stop)
    : Math.max(segment.stop + milliseconds, segment.start);
